export function RestaurantSteakhouseStyles() {
    return (
        <style>{`
            [data-web-template="restaurant-modern"] {
                --steakhouse-orange: var(--site-primary, #f7941d);
                --steakhouse-orange-ink: var(--site-on-primary, #3b3b3b);
                --steakhouse-charcoal: var(--site-text, #3b3b3b);
                --steakhouse-paper: var(--site-background, #ffffff);
                --steakhouse-soft: color-mix(in srgb, var(--steakhouse-charcoal) 6%, var(--steakhouse-paper));
                --steakhouse-rule: color-mix(in srgb, var(--steakhouse-charcoal) 28%, transparent);
                background: var(--steakhouse-paper);
                color: var(--steakhouse-charcoal);
                font-family: var(--site-body-font), Arial, sans-serif;
            }

            /* Older applied snapshots persisted former template defaults as
               authored values. Repair only those exact seeds so later user
               customizations keep their authority. */
            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="header"][style*="--site-builder-authored-position: sticky"] {
                position: fixed !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-document-role="heroHeading"] .site-builder-text[style*="--site-builder-authored-color: var(--site-text)"] {
                color: #ffffff !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="experience"][style*="--site-builder-authored-border-color: rgba(255,255,255,.10)"] {
                border: 0 !important;
                border-block: 4px dotted color-mix(in srgb, #ffffff 88%, transparent) !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="experience"] > .site-builder-grid > .site-builder-grid-item > .site-builder-column:is(
                [style*="--site-builder-authored-background-color: var(--site-surface)"],
                [style*="--site-builder-authored-background-color: rgba(255,255,255,.055)"]
            ) {
                background: transparent !important;
                border: 0 !important;
                border-radius: 0 !important;
                box-shadow: none !important;
                padding: 0 !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="experience"] .site-builder-column > [data-site-builder-block="text"]:first-child .site-builder-text[style*="--site-builder-authored-font-size: 42px"] {
                font-size: .72rem !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:first-child[style*="--site-builder-authored-grid-column: 1 / span 4"] {
                grid-column: 1 / span 5 !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(2)[style*="--site-builder-authored-grid-column: 5 / span 8"] {
                grid-column: 6 / span 7 !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:first-child[style*="--site-builder-authored-grid-column: 1 / span 7"] {
                grid-column: 1 / span 6 !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:nth-child(2)[style*="--site-builder-authored-grid-column: 8 / span 5"] {
                grid-column: 7 / span 6 !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) > .site-builder-column[style*="--site-builder-authored-background-color: rgba(255,255,255,.06)"] {
                background: transparent !important;
                border: 0 !important;
                border-radius: 0 !important;
                box-shadow: none !important;
                padding: 0 !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="occasions"][style*="--site-builder-authored-background-color: var(--site-background)"] {
                background: var(--steakhouse-orange) !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:first-child[style*="--site-builder-authored-grid-column: 1 / span 5"] {
                grid-column: 1 / span 4 !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(2)[style*="--site-builder-authored-grid-column: 7 / span 6"] {
                grid-column: 5 / span 8 !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="occasions"] .site-builder-image[style*="--site-builder-authored-border-radius: 40px"] {
                border: 4px solid color-mix(in srgb, var(--steakhouse-charcoal) 18%, transparent) !important;
                border-radius: 50% !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="occasions"] .site-builder-card:is(
                [style*="--site-builder-authored-background-color: var(--site-surface)"],
                [style*="--site-builder-authored-background-color: rgba(255,255,255,.045)"]
            ) {
                background: var(--steakhouse-charcoal) !important;
                border: 3px solid color-mix(in srgb, #ffffff 42%, transparent) !important;
                border-radius: 50% !important;
                box-shadow: none !important;
                padding: clamp(.75rem, 2vw, 1.35rem) !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="occasions"] .site-builder-card:is(
                [style*="--site-builder-authored-background-color: var(--site-surface)"],
                [style*="--site-builder-authored-background-color: rgba(255,255,255,.045)"]
            ) .site-builder-text:is(
                [style*="--site-builder-authored-color: var(--site-on-surface)"],
                [style*="--site-builder-authored-color: var(--site-text)"]
            ) {
                color: var(--steakhouse-paper) !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="occasions"] .site-builder-card .site-builder-text[style*="--site-builder-authored-font-size: 22px"] {
                font-size: clamp(.82rem, 1.35vw, 1.05rem) !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="reservation"] > .site-builder-grid > .site-builder-grid-item > .site-builder-column:is(
                [style*="--site-builder-authored-background-color: rgba(255,255,255,.06)"],
                [style*="--site-builder-authored-background-color: rgba(255,255,255,.05)"]
            ) {
                background: transparent !important;
                border: 0 !important;
                border-radius: 0 !important;
                box-shadow: none !important;
                padding: 0 !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-document-role="openingHoursTable"] > .site-builder-column-inline > [data-site-builder-block="text"] > .site-builder-text[style*="--site-builder-authored-width: calc(50% - 6px)"] {
                width: 100% !important;
            }

            [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) :is(
                .site-builder-form[style*="--site-builder-authored-background-color: rgba(11,12,10,.72)"],
                .site-builder-column[style*="--site-builder-authored-background-color: rgba(11,12,10,.60)"]
            ) {
                background: transparent !important;
                border: 0 !important;
                border-radius: 0 !important;
                box-shadow: none !important;
                padding: 0 !important;
            }

            [data-web-template="restaurant-modern"] .site-builder-section {
                padding: clamp(4.75rem, 8vw, 7rem) 1.25rem;
            }

            [data-web-template="restaurant-modern"] .site-builder-grid {
                width: min(100%, 1000px) !important;
            }

            [data-web-template="restaurant-modern"] :where(
                h1,
                h2,
                h3,
                [data-document-role="heroHeading"],
                .site-builder-heading
            ) {
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, "Roboto Serif", Georgia, serif !important;
                font-weight: 800 !important;
            }

            [data-web-template="restaurant-modern"] :where(
                .site-builder-card,
                .site-builder-image,
                .site-builder-button,
                .site-builder-badge,
                input,
                textarea,
                select
            ) {
                border-radius: 1px !important;
            }

            [data-web-template="restaurant-modern"] .site-builder-card,
            [data-web-template="restaurant-modern"] .site-builder-card:hover,
            [data-web-template="restaurant-modern"] .site-builder-card:focus-within {
                box-shadow: none !important;
                transform: none !important;
            }

            [data-web-template="restaurant-modern"] :where(
                [data-web-region="gallery"],
                [data-web-region="occasions"]
            ) :where(.site-builder-image, .site-builder-card):hover img {
                filter: none !important;
                transform: none !important;
            }

            /* The reference hides its orange desktop navigation over the opening
               photograph and slides it in only after the hero has passed. */
            @container restaurant-template (min-width: 901px) {
                [data-web-template="restaurant-modern"] [data-web-region="header"] {
                    background: var(--steakhouse-orange) !important;
                    border: 0 !important;
                    box-shadow: 0 8px 22px rgba(59, 59, 59, .16) !important;
                    display: block !important;
                    min-height: 80px !important;
                    pointer-events: none;
                    transform: translateY(-105%);
                    transition: transform 320ms cubic-bezier(.22, 1, .36, 1) !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="header"][data-restaurant-header-scrolled] {
                    backdrop-filter: none !important;
                    background: var(--steakhouse-orange) !important;
                    min-height: 80px !important;
                    pointer-events: auto;
                    transform: translateY(0);
                }

                [data-web-template="restaurant-modern"] [data-web-region="header"] :where(
                    .site-builder-text,
                    .site-builder-text > span,
                    .site-builder-icon
                ) {
                    color: var(--steakhouse-orange-ink) !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="header"][data-restaurant-header-scrolled]
                    .site-navigation-primary-minimalReveal :is(
                        .site-navigation-primary-trigger,
                        .site-navigation-primary-link,
                        .site-navigation-primary-toggle
                    ) {
                    color: var(--steakhouse-orange-ink) !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="header"] [data-document-role="headerCta"] {
                    background: transparent !important;
                    border: 1px solid var(--steakhouse-orange-ink) !important;
                    color: var(--steakhouse-orange-ink) !important;
                }
            }

            /* Full-bleed, warm photographic opening with a compact centered mark. */
            [data-web-template="restaurant-modern"] [data-web-region="hero"] {
                align-items: center !important;
                background-color: #24170f !important;
                background-position: center !important;
                background-size: cover !important;
                display: grid;
                min-height: 100svh !important;
                padding: clamp(6rem, 13vh, 9rem) 1.25rem clamp(3rem, 7vh, 5rem) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="hero"]::before {
                background:
                    linear-gradient(180deg, rgba(18, 10, 5, .2), rgba(18, 10, 5, .06) 38%, rgba(18, 10, 5, .64)),
                    linear-gradient(90deg, rgba(18, 10, 5, .24), transparent 48%, rgba(18, 10, 5, .18)) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="hero"] > .site-builder-grid {
                align-items: center !important;
                display: grid !important;
                grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
                min-height: calc(100svh - clamp(9rem, 20vh, 14rem)) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="hero"] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="heroCopy"]) {
                align-self: center !important;
                grid-column: 2 / span 10 !important;
                grid-row: 1 !important;
                justify-self: stretch !important;
            }

            [data-web-template="restaurant-modern"] [data-document-role="heroCopy"] {
                align-content: center !important;
                justify-items: center !important;
                margin-inline: auto;
                max-width: 760px;
                position: relative;
                text-align: center;
            }

            [data-web-template="restaurant-modern"] [data-document-role="heroCopy"]::before {
                align-items: center;
                border: 2px solid var(--steakhouse-orange);
                color: var(--steakhouse-orange);
                content: "✦";
                display: flex;
                font-family: var(--font-eb-garamond, "EB Garamond"), Georgia, serif;
                font-size: 1.5rem;
                height: 58px;
                justify-content: center;
                margin: 0 auto .5rem;
                position: relative;
                transform: rotate(-3deg);
                width: 112px;
            }

            [data-web-template="restaurant-modern"] [data-document-role="heroCopy"]::after {
                background: var(--steakhouse-orange);
                content: "";
                height: 2px;
                left: 50%;
                position: absolute;
                top: 28px;
                transform: translateX(-50%);
                width: 164px;
                z-index: -1;
            }

            [data-web-template="restaurant-modern"] [data-document-role="heroHeading"] {
                color: #ffffff !important;
                font-size: clamp(3.2rem, 7vw, 6.6rem) !important;
                letter-spacing: -.035em !important;
                line-height: .9 !important;
                max-width: 760px !important;
                text-align: center !important;
                text-shadow: 0 3px 24px rgba(0, 0, 0, .38);
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-document-role="heroHeading"] :where(
                .site-builder-text,
                .site-builder-text > span
            ) {
                color: #ffffff !important;
            }

            [data-web-template="restaurant-modern"] [data-document-role="heroDescription"] {
                color: #ffffff !important;
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: clamp(.78rem, 1.4vw, .98rem) !important;
                font-weight: 700 !important;
                letter-spacing: .06em !important;
                line-height: 1.65 !important;
                margin-inline: auto;
                max-width: 620px !important;
                text-align: center !important;
                text-shadow: 0 2px 14px rgba(0, 0, 0, .45);
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] :where(
                [data-document-role="heroPrimaryAction"],
                [data-document-role="heroSecondaryAction"]
            ) {
                justify-self: center !important;
                min-width: 11rem;
                width: auto !important;
            }

            [data-web-template="restaurant-modern"] :where(
                [data-document-role="heroPrimaryAction"],
                [data-document-role="heroSecondaryAction"]
            ) .site-builder-button {
                background: rgba(20, 12, 7, .24) !important;
                border: 1px solid rgba(255, 255, 255, .88) !important;
                box-shadow: none !important;
                color: #ffffff !important;
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: .7rem !important;
                font-weight: 800 !important;
                letter-spacing: .08em;
                min-height: 43px;
                padding: .75rem 1.1rem !important;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] :where(
                [data-document-role="heroPrimaryAction"],
                [data-document-role="heroSecondaryAction"]
            ) .site-builder-button:hover {
                background: var(--steakhouse-orange) !important;
                border-color: var(--steakhouse-orange) !important;
                color: var(--steakhouse-orange-ink) !important;
            }

            [data-web-template="restaurant-modern"] :where(
                [data-document-role="heroHighlightOne"],
                [data-document-role="heroHighlightTwo"],
                [data-document-role="heroHighlightThree"]
            ) {
                align-self: end;
                background: rgba(18, 10, 5, .34) !important;
                border: 1px solid rgba(255, 255, 255, .65) !important;
                box-shadow: none !important;
                color: #ffffff !important;
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: .58rem !important;
                font-weight: 800 !important;
                justify-self: stretch !important;
                letter-spacing: .06em;
                margin-top: clamp(2rem, 8vh, 5rem);
                min-width: 0 !important;
                padding: .65rem .55rem !important;
                text-align: center;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-document-role="heroFeature"],
            [data-web-template="restaurant-modern"] [data-web-region="hero"] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="heroFeature"]) {
                display: none !important;
            }

            /* Orange introductory band, with the reference's dotted cut edge. */
            [data-web-template="restaurant-modern"] [data-web-region="experience"] {
                background: var(--steakhouse-orange) !important;
                border-block: 4px dotted color-mix(in srgb, #ffffff 88%, transparent) !important;
                color: var(--steakhouse-orange-ink) !important;
                min-height: 0 !important;
                padding-block: clamp(3.25rem, 6vw, 5rem) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="experience"] > .site-builder-grid {
                gap: 0 !important;
                grid-template-columns: minmax(0, 1fr) !important;
                max-width: 760px;
            }

            [data-web-template="restaurant-modern"] [data-web-region="experience"] > .site-builder-grid > .site-builder-grid-item {
                background: transparent !important;
                border: 0 !important;
                grid-column: 1 / -1 !important;
                grid-row: auto !important;
                padding: 0 !important;
                text-align: center;
            }

            [data-web-template="restaurant-modern"] [data-web-region="experience"] > .site-builder-grid > .site-builder-grid-item > .site-builder-column {
                background: transparent !important;
                border: 0 !important;
                border-radius: 0 !important;
                padding: 0 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="experience"] .site-builder-column {
                align-content: start;
                justify-items: center;
            }

            [data-web-template="restaurant-modern"] [data-web-region="experience"] :where(.site-builder-text, .site-builder-text > span, .site-builder-icon) {
                color: var(--steakhouse-orange-ink) !important;
                text-align: center !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="experience"] .site-builder-column > [data-site-builder-block="text"]:first-child .site-builder-text {
                align-items: center;
                background: var(--steakhouse-charcoal);
                border-radius: 50% !important;
                color: var(--steakhouse-paper) !important;
                display: flex;
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: .72rem !important;
                font-weight: 800 !important;
                height: 2.45rem;
                justify-content: center;
                line-height: 1 !important;
                margin-inline: auto;
                width: 2.45rem !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="experience"] .site-builder-column > [data-site-builder-block="text"]:nth-child(2) .site-builder-text {
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: clamp(1.05rem, 2vw, 1.35rem) !important;
                font-weight: 800 !important;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-web-region="experience"] .site-builder-column > [data-site-builder-block="text"]:last-child .site-builder-text {
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: .78rem !important;
                line-height: 1.7 !important;
                max-width: 17rem;
            }

            /* Menu is editorial rather than a collection of floating cards. */
            [data-web-template="restaurant-modern"] [data-web-region="menu"] {
                background: var(--steakhouse-paper) !important;
                color: var(--steakhouse-charcoal) !important;
                min-height: 0 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] :where(.site-builder-text, .site-builder-text > span, .site-builder-icon) {
                color: var(--steakhouse-charcoal) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid {
                column-gap: clamp(.75rem, 1.5vw, 1.25rem) !important;
                row-gap: clamp(2.5rem, 5vw, 4.5rem) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:first-child {
                align-self: center !important;
                grid-column: 1 / span 6 !important;
                grid-row: 1 / span 3 !important;
                text-align: right;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) {
                align-self: center !important;
                background: transparent !important;
                border: 0 !important;
                border-left: 1px dotted var(--steakhouse-rule) !important;
                grid-column: 7 / span 6 !important;
                grid-row: 1 / span 3 !important;
                padding: .5rem 0 .5rem clamp(1.5rem, 4vw, 3rem) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(n+3) {
                background: transparent !important;
                border: 0 !important;
                border-top: 1px dotted var(--steakhouse-rule) !important;
                grid-row: auto !important;
                padding: 1.35rem 0 0 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(3),
            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(5) {
                grid-column: 1 / span 6 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(4),
            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(6) {
                grid-column: 7 / span 6 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(3),
            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(4) {
                grid-row: 5 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(5),
            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(6) {
                grid-row: 8 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:first-child [data-site-builder-block="text"]:nth-child(2) .site-builder-text {
                color: var(--steakhouse-charcoal) !important;
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: clamp(2.2rem, 4.8vw, 3.8rem) !important;
                font-weight: 800 !important;
                line-height: 1 !important;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:first-child [data-site-builder-block="text"]:nth-child(2)::after {
                border-top: 2px dotted var(--steakhouse-orange);
                content: "";
                display: block;
                margin: 1rem 0 1.25rem auto;
                width: 7rem;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] .site-builder-card {
                background: transparent !important;
                border: 0 !important;
                overflow: visible !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="menu"] .site-builder-card-content-inline > .site-builder-badge,
            [data-web-template="restaurant-modern"] [data-web-region="menu"] .site-builder-badge {
                align-items: center;
                background: var(--steakhouse-orange) !important;
                border: 0 !important;
                border-radius: 50% !important;
                box-shadow: none !important;
                color: var(--steakhouse-orange-ink) !important;
                display: flex;
                flex: 0 0 3.75rem;
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: .64rem !important;
                font-weight: 800 !important;
                height: 3.75rem;
                justify-content: center;
                min-width: 3.75rem !important;
                padding: .35rem !important;
                text-align: center;
            }

            /* Two clean, alternating image-and-copy rows drawn from gallery blocks. */
            [data-web-template="restaurant-modern"] [data-web-region="gallery"] {
                background: var(--steakhouse-paper) !important;
                border-block: 4px dotted color-mix(in srgb, var(--steakhouse-orange) 76%, transparent) !important;
                color: var(--steakhouse-charcoal) !important;
                min-height: 0 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="gallery"] :where(.site-builder-text, .site-builder-text > span, .site-builder-icon) {
                color: var(--steakhouse-charcoal) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid {
                column-gap: 0 !important;
                grid-auto-rows: auto !important;
                row-gap: clamp(4rem, 9vw, 7rem) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item {
                grid-row: auto !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:first-child {
                align-self: center !important;
                grid-column: 1 / span 6 !important;
                grid-row: 1 !important;
                min-height: 360px;
                padding: 0 !important;
                position: relative;
            }

            [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) {
                align-self: center !important;
                background: transparent !important;
                border: 0 !important;
                grid-column: 7 / span 6 !important;
                grid-row: 1 !important;
                padding-left: clamp(1.5rem, 3vw, 3rem) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) [data-site-builder-block="text"]:nth-child(2) .site-builder-text {
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: clamp(2rem, 4vw, 3.25rem) !important;
                font-weight: 800 !important;
                line-height: .98 !important;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) [data-site-builder-block="text"]:nth-child(2)::after {
                border-top: 2px dotted var(--steakhouse-orange);
                content: "";
                display: block;
                margin-block: 1rem 1.25rem;
                width: 7rem;
            }

            [data-web-template="restaurant-modern"] [data-web-region="gallery"] .site-builder-image {
                border: 2px solid var(--steakhouse-charcoal) !important;
                height: 100% !important;
                min-height: 360px;
            }

            [data-web-template="restaurant-modern"] [data-web-region="gallery"] .site-builder-image img {
                height: 100% !important;
                object-fit: cover !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:first-child::after {
                align-items: center;
                background: var(--steakhouse-orange);
                border: 2px solid var(--steakhouse-paper);
                border-radius: 50%;
                color: var(--steakhouse-orange-ink);
                content: "›";
                display: flex;
                font-family: var(--font-eb-garamond, "EB Garamond"), Georgia, serif;
                font-size: 2rem;
                height: 2.5rem;
                justify-content: center;
                line-height: 1;
                position: absolute;
                right: -1.25rem;
                top: 50%;
                transform: translateY(-50%);
                width: 2.5rem;
                z-index: 2;
            }

            /* Orange occasion/team strip with round portrait and round choices. */
            [data-web-template="restaurant-modern"] [data-web-region="occasions"] {
                background: var(--steakhouse-orange) !important;
                border-block: 4px dotted color-mix(in srgb, #ffffff 88%, transparent) !important;
                color: var(--steakhouse-orange-ink) !important;
                min-height: 0 !important;
                padding-block: clamp(4rem, 7vw, 6rem) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] :where(.site-builder-text, .site-builder-text > span, .site-builder-icon) {
                color: var(--steakhouse-orange-ink) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid {
                align-items: center !important;
                column-gap: clamp(.75rem, 1.5vw, 1.25rem) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:first-child {
                align-self: center !important;
                grid-column: 1 / span 4 !important;
                grid-row: 1 !important;
                justify-self: center;
                max-width: 280px;
                width: 100%;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:first-child .site-builder-image {
                aspect-ratio: 1;
                border: 4px solid color-mix(in srgb, var(--steakhouse-charcoal) 18%, transparent) !important;
                border-radius: 50% !important;
                height: auto !important;
                overflow: hidden;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:first-child img {
                filter: saturate(.72) contrast(1.06);
                height: 100% !important;
                object-fit: cover !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) {
                grid-column: 5 / span 8 !important;
                grid-row: 1 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) > .site-builder-column {
                align-items: stretch !important;
                display: grid !important;
                gap: 1rem !important;
                grid-template-columns: repeat(3, minmax(0, 1fr));
                text-align: center;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) > .site-builder-column > [data-site-builder-block="text"] {
                grid-column: 1 / -1;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) > .site-builder-column > [data-site-builder-block="text"]:nth-child(2) .site-builder-text {
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: clamp(2rem, 4.4vw, 3.4rem) !important;
                font-weight: 800 !important;
                line-height: .98 !important;
                text-align: center !important;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) > .site-builder-column > .site-builder-card {
                align-content: center;
                aspect-ratio: 1;
                background: var(--steakhouse-charcoal) !important;
                border: 3px solid color-mix(in srgb, #ffffff 42%, transparent) !important;
                border-radius: 50% !important;
                color: var(--steakhouse-paper) !important;
                display: grid;
                grid-column: auto;
                margin-top: 1rem;
                max-width: 11rem;
                overflow: hidden;
                padding: clamp(.75rem, 2vw, 1.35rem) !important;
                width: 100%;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] .site-builder-card :where(.site-builder-text, .site-builder-text > span, .site-builder-icon) {
                color: var(--steakhouse-paper) !important;
                text-align: center !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] .site-builder-card [data-site-builder-block="text"]:first-child .site-builder-text {
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: clamp(.82rem, 1.35vw, 1.05rem) !important;
                font-weight: 800 !important;
                line-height: 1.1 !important;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] .site-builder-card [data-site-builder-block="text"]:last-child .site-builder-text {
                font-size: clamp(.56rem, .8vw, .7rem) !important;
                line-height: 1.35 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="occasions"] .site-builder-card [data-site-builder-block="text"]:last-child {
                display: none;
            }

            /* Contact and booking stay quiet, white and square. */
            [data-web-template="restaurant-modern"] :where(
                [data-web-region="reservation"],
                [data-web-region="reservationPage"]
            ) {
                background: var(--steakhouse-paper) !important;
                color: var(--steakhouse-charcoal) !important;
                min-height: 0 !important;
            }

            [data-web-template="restaurant-modern"] :where(
                [data-web-region="reservation"],
                [data-web-region="reservationPage"]
            ) :where(.site-builder-text, .site-builder-text > span, .site-builder-icon) {
                color: var(--steakhouse-charcoal) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="reservation"] > .site-builder-grid {
                column-gap: clamp(.75rem, 1.5vw, 1.25rem) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="reservation"] > .site-builder-grid > .site-builder-grid-item {
                background: transparent !important;
                border: 0 !important;
                grid-row: 1 !important;
                padding: 0 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="reservation"] > .site-builder-grid > .site-builder-grid-item:first-child {
                grid-column: 1 / span 7 !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="reservation"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) {
                border-left: 1px dotted var(--steakhouse-rule) !important;
                grid-column: 8 / span 5 !important;
                padding-left: clamp(2rem, 5vw, 4rem) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="reservation"] > .site-builder-grid > .site-builder-grid-item:first-child > [data-site-builder-block="text"]:nth-child(2) .site-builder-text,
            [data-web-template="restaurant-modern"] [data-web-region="reservationPage"] h1,
            [data-web-template="restaurant-modern"] [data-web-region="reservationPage"] h2 {
                color: var(--steakhouse-charcoal) !important;
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: clamp(2.2rem, 4.8vw, 3.8rem) !important;
                font-weight: 800 !important;
                line-height: 1 !important;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-web-region="reservation"] > .site-builder-grid > .site-builder-grid-item:first-child > [data-site-builder-block="text"]:nth-child(2)::after {
                border-top: 2px dotted var(--steakhouse-orange);
                content: "";
                display: block;
                margin-block: 1rem 1.5rem;
                width: 7rem;
            }

            [data-web-template="restaurant-modern"] .site-template-lead-form {
                background: transparent !important;
                border: 0 !important;
                box-shadow: none !important;
                padding: 1rem 0 0 !important;
            }

            [data-web-template="restaurant-modern"] .site-template-lead-form label > span {
                color: var(--steakhouse-charcoal) !important;
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: .68rem !important;
                font-weight: 800 !important;
                letter-spacing: .055em;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] .site-template-lead-form :where(input, textarea, select) {
                background: transparent !important;
                border: 1px solid color-mix(in srgb, var(--steakhouse-charcoal) 44%, transparent) !important;
                box-shadow: none !important;
                color: var(--steakhouse-charcoal) !important;
            }

            [data-web-template="restaurant-modern"] .site-template-lead-form button,
            [data-web-template="restaurant-modern"] :where(
                [data-web-region="reservation"],
                [data-web-region="reservationPage"]
            ) .site-builder-button {
                background: var(--steakhouse-orange) !important;
                border: 1px solid var(--steakhouse-orange) !important;
                box-shadow: none !important;
                color: var(--steakhouse-orange-ink) !important;
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: .7rem !important;
                font-weight: 800 !important;
                letter-spacing: .055em;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-document-role="openingHoursTable"] > .site-builder-column-inline {
                border-bottom: 1px dotted var(--steakhouse-rule);
                padding-block: .45rem;
            }

            [data-web-template="restaurant-modern"] :where(
                [data-document-role="contactAddress"],
                [data-document-role="contactPhone"],
                [data-document-role="contactEmail"]
            ) .site-builder-text {
                font-size: .82rem !important;
                line-height: 1.55 !important;
            }

            /* Inner pages inherit the same square, editorial visual language. */
            [data-web-template="restaurant-modern"] :where(
                [data-web-region="contentHero"],
                [data-web-region="storyHero"]
            ) {
                background-color: #24170f !important;
                background-position: center !important;
                background-size: cover !important;
                color: #ffffff !important;
                min-height: min(72svh, 680px) !important;
            }

            [data-web-template="restaurant-modern"] :where(
                [data-web-region="contentHero"],
                [data-web-region="storyHero"]
            )::before {
                background: linear-gradient(0deg, rgba(18, 10, 5, .7), rgba(18, 10, 5, .2)) !important;
            }

            [data-web-template="restaurant-modern"] :where(
                [data-web-region="contentHero"],
                [data-web-region="storyHero"]
            ) :where(
                .site-builder-text,
                .site-builder-text > span,
                .site-builder-icon,
                [data-site-builder-block="blockquote"],
                [data-site-builder-block="blockquote"] *
            ) {
                color: #ffffff !important;
            }

            [data-web-template="restaurant-modern"] :where(
                [data-web-region="contentHero"],
                [data-web-region="storyHero"]
            ) h1 {
                font-size: clamp(3rem, 7vw, 6rem) !important;
                line-height: .92 !important;
                text-align: center;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-web-region="fullMenu"] {
                background: var(--steakhouse-paper) !important;
                color: var(--steakhouse-charcoal) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="fullMenu"] :where(
                .site-builder-text,
                .site-builder-text > span,
                .site-builder-icon
            ) {
                color: var(--steakhouse-charcoal) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="fullMenu"] :where(.site-builder-card, .site-builder-column) {
                background: transparent !important;
                border-radius: 0 !important;
                box-shadow: none !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="values"] {
                background: var(--steakhouse-orange) !important;
                border-block: 4px dotted color-mix(in srgb, #ffffff 88%, transparent) !important;
                color: var(--steakhouse-orange-ink) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="values"] :where(.site-builder-text, .site-builder-text > span, .site-builder-icon) {
                color: var(--steakhouse-orange-ink) !important;
            }

            /* Solid orange closing block, compact like the reference newsletter/footer. */
            [data-web-template="restaurant-modern"] [data-web-region="footer"] {
                background: var(--steakhouse-orange) !important;
                border-top: 4px dotted color-mix(in srgb, #ffffff 88%, transparent) !important;
                color: var(--steakhouse-orange-ink) !important;
                padding: clamp(3rem, 6vw, 4.75rem) 1.25rem 2rem !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="footer"] :where(.site-builder-text, .site-builder-text > span, .site-builder-icon) {
                color: var(--steakhouse-orange-ink) !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="footer"] > .site-builder-grid {
                column-gap: clamp(1.5rem, 4vw, 3rem) !important;
                row-gap: 2rem !important;
            }

            [data-web-template="restaurant-modern"] [data-web-region="footer"] .site-builder-navigation-link:hover,
            [data-web-template="restaurant-modern"] [data-web-region="footer"] a:hover :where(.site-builder-text, .site-builder-text > span) {
                color: var(--steakhouse-charcoal) !important;
                text-decoration: underline;
                text-underline-offset: .25rem;
            }

            [data-web-template="restaurant-modern"] [data-document-role="footerBrand"] [data-site-builder-block="text"]:first-child .site-builder-text {
                font-family: var(--font-roboto-slab, "Roboto Slab"), Rockwell, Georgia, serif !important;
                font-size: 1.65rem !important;
                font-weight: 900 !important;
                text-transform: uppercase;
            }

            [data-web-template="restaurant-modern"] [data-document-role="footerSocial"] a {
                align-items: center;
                background: var(--steakhouse-charcoal) !important;
                border-radius: 50% !important;
                color: var(--steakhouse-paper) !important;
                display: inline-flex;
                height: 2.35rem;
                justify-content: center;
                width: 2.35rem;
            }

            [data-web-template="restaurant-modern"] [data-document-role="footerSocial"] a .site-builder-icon {
                color: var(--steakhouse-paper) !important;
            }

            [data-web-template="restaurant-modern"] [data-document-role="footerDivider"] .site-builder-separator {
                border-color: color-mix(in srgb, var(--steakhouse-charcoal) 28%, transparent) !important;
                border-style: dotted !important;
            }

            [data-web-template="restaurant-modern"] [data-document-role="footerLegal"] {
                text-align: center;
            }

            @container restaurant-template (max-width: 900px) {
                [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="header"][style*="--site-builder-authored-position: sticky"] {
                    background: linear-gradient(180deg, rgba(18, 10, 5, .78), transparent) !important;
                    border: 0 !important;
                    box-shadow: none !important;
                    display: block !important;
                    min-height: 72px !important;
                    position: absolute !important;
                }

                [data-web-template="restaurant-modern"]:not(#__restaurant-modern-legacy-seed) [data-web-region="header"][style*="--site-builder-authored-position: sticky"][data-restaurant-mobile-menu-open] {
                    background: var(--steakhouse-paper) !important;
                    min-height: 100svh !important;
                    position: fixed !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="header"][data-restaurant-mobile-menu-open] :where(
                    [data-document-role="brandCopy"],
                    [data-document-role="headerNavigation"]
                ) :where(.site-builder-text, .site-builder-text > span, .site-builder-icon) {
                    color: var(--steakhouse-charcoal) !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="header"] [data-document-role="brandCopy"] {
                    background: transparent !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="header"] [data-document-role="brandCopy"] > [data-site-builder-block="text"]:last-child {
                    display: none !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="header"] [data-document-role="brandCopy"] .site-builder-text > span,
                [data-web-template="restaurant-modern"] [data-web-region="header"] [data-document-role="headerNavigation"] .site-builder-text > span {
                    color: #ffffff !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="header"] .restaurant-mobile-menu-toggle {
                    background: var(--steakhouse-orange) !important;
                    border: 0 !important;
                    border-radius: 50% !important;
                    opacity: 1 !important;
                    pointer-events: auto !important;
                    transform: none !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="header"] .restaurant-mobile-menu-toggle > span {
                    background: var(--steakhouse-orange-ink) !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="hero"] {
                    min-height: 100svh !important;
                    padding: 7rem 1rem 2rem !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="hero"] > .site-builder-grid {
                    min-height: calc(100svh - 9rem) !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="hero"] > .site-builder-grid > .site-builder-grid-item:has(> [data-document-role="heroCopy"]) {
                    grid-column: 1 / -1 !important;
                }

                [data-web-template="restaurant-modern"] [data-document-role="heroCopy"] {
                    column-gap: .65rem !important;
                    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
                    row-gap: 1rem !important;
                }

                [data-web-template="restaurant-modern"] [data-document-role="heroCopy"]::before,
                [data-web-template="restaurant-modern"] [data-document-role="heroHeading"],
                [data-web-template="restaurant-modern"] [data-document-role="heroDescription"] {
                    grid-column: 1 / -1 !important;
                }

                [data-web-template="restaurant-modern"] [data-document-role="heroHeading"] {
                    font-size: clamp(2.75rem, 14vw, 4.7rem) !important;
                }

                [data-web-template="restaurant-modern"] :where(
                    [data-document-role="heroPrimaryAction"],
                    [data-document-role="heroSecondaryAction"]
                ) {
                    grid-column: 1 / -1 !important;
                    width: min(100%, 19rem) !important;
                }

                [data-web-template="restaurant-modern"] :where(
                    [data-document-role="heroHighlightOne"],
                    [data-document-role="heroHighlightTwo"],
                    [data-document-role="heroHighlightThree"]
                ) {
                    grid-column: auto !important;
                    margin-top: 1.25rem;
                    padding-inline: .25rem !important;
                }

                [data-web-template="restaurant-modern"] [data-document-role="heroHighlightOne"] {
                    grid-column: 1 / span 4 !important;
                }

                [data-web-template="restaurant-modern"] [data-document-role="heroHighlightTwo"] {
                    grid-column: 5 / span 4 !important;
                }

                [data-web-template="restaurant-modern"] [data-document-role="heroHighlightThree"] {
                    grid-column: 9 / span 4 !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="experience"] > .site-builder-grid {
                    gap: 2rem !important;
                    grid-template-columns: minmax(0, 1fr) !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="experience"] > .site-builder-grid > .site-builder-grid-item {
                    grid-column: 1 !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="experience"] .site-builder-column > [data-site-builder-block="text"]:last-child .site-builder-text {
                    max-width: 25rem;
                }

                [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(n),
                [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:nth-child(n),
                [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(n),
                [data-web-template="restaurant-modern"] [data-web-region="reservation"] > .site-builder-grid > .site-builder-grid-item:nth-child(n) {
                    grid-column: 1 / -1 !important;
                    grid-row: auto !important;
                    width: 100%;
                }

                [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:first-child {
                    text-align: left;
                }

                [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:first-child [data-site-builder-block="text"]:nth-child(2)::after {
                    margin-left: 0;
                }

                [data-web-template="restaurant-modern"] [data-web-region="menu"] > .site-builder-grid > .site-builder-grid-item:nth-child(2),
                [data-web-template="restaurant-modern"] [data-web-region="reservation"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) {
                    border-left: 0 !important;
                    border-top: 1px dotted var(--steakhouse-rule) !important;
                    padding: 2rem 0 0 !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid {
                    row-gap: 2rem !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) {
                    padding: 0 !important;
                    text-align: left;
                }

                [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) [data-site-builder-block="text"]:nth-child(2)::after {
                    margin-left: 0;
                }

                [data-web-template="restaurant-modern"] [data-web-region="gallery"] .site-builder-image,
                [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:first-child {
                    min-height: 260px;
                }

                [data-web-template="restaurant-modern"] [data-web-region="gallery"] > .site-builder-grid > .site-builder-grid-item:first-child::after {
                    left: auto;
                    right: .75rem;
                    top: auto;
                    bottom: .75rem;
                    transform: none;
                }

                [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:first-child {
                    margin-inline: auto;
                    max-width: 220px;
                }

                [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) {
                    margin-top: 1.5rem;
                }

                [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) > .site-builder-column {
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                }

                [data-web-template="restaurant-modern"] [data-web-region="occasions"] .site-builder-card [data-site-builder-block="text"]:last-child {
                    display: none;
                }

                [data-web-template="restaurant-modern"] [data-web-region="footer"] > .site-builder-grid > .site-builder-grid-item {
                    grid-column: 1 / -1 !important;
                    grid-row: auto !important;
                    text-align: center;
                }

                [data-web-template="restaurant-modern"] [data-web-region="footer"] .site-builder-navigation,
                [data-web-template="restaurant-modern"] [data-document-role="footerSocial"] {
                    justify-content: center !important;
                }
            }

            @container restaurant-template (max-width: 560px) {
                [data-web-template="restaurant-modern"] .site-builder-section {
                    padding-inline: 1rem;
                }

                [data-web-template="restaurant-modern"] :where(
                    [data-document-role="heroHighlightOne"],
                    [data-document-role="heroHighlightTwo"],
                    [data-document-role="heroHighlightThree"]
                ) {
                    font-size: .48rem !important;
                    letter-spacing: .025em;
                }

                [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) > .site-builder-column {
                    gap: .5rem !important;
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                }

                [data-web-template="restaurant-modern"] [data-web-region="occasions"] > .site-builder-grid > .site-builder-grid-item:nth-child(2) > .site-builder-column > .site-builder-card {
                    border-width: 2px !important;
                    padding: .5rem !important;
                }

                [data-web-template="restaurant-modern"] [data-web-region="occasions"] .site-builder-card [data-site-builder-block="text"]:first-child .site-builder-text {
                    font-size: clamp(.58rem, 2.6vw, .76rem) !important;
                }
            }

            @media (prefers-reduced-motion: reduce) {
                [data-web-template="restaurant-modern"] *,
                [data-web-template="restaurant-modern"] *::before,
                [data-web-template="restaurant-modern"] *::after {
                    scroll-behavior: auto !important;
                    transition-duration: .01ms !important;
                }
            }
        `}</style>
    );
}
